import styles from '../styles/headers.module.scss'
import { ReactComponent as UndoIcon } from '@ui-kit/icons/undo.svg';

function SearchResultHeader() {

  return (
    <div className={styles.mainHeader}>
      <div className={styles.header}>
        <div className={styles.info}>
          <button className={styles.btn}><UndoIcon height={17} width={17}/></button>
          <p>search result</p>
        </div>
        <div className={styles.category}>posted by</div>
        <div className={styles.category}>date</div>
      </div>
    </div>
  )
}

export default SearchResultHeader